module.exports = __webpack_public_path__ + "static/media/reaction.59f5d5c6.svg";